(function($, undefined) {
	
	'use strict';
	var inputs;
	
	var init = function () {
        inputs = $('.input-ctn');
        
		/* Animation on click of input to replace the 
		label on top of written input content */
		inputs.focusin(function() {
            $(this).addClass("focused");
		});
		inputs.focusout(function() {
            if($(this).find("input").length !== 0 && $(this).find("input").val() === ''){
                $(this).removeClass("focused");
            }
            if($(this).find("select").length !== 0 && $(this).find("select").val() === ''){
                $(this).removeClass("focused");
            }
           	if($(this).find("textarea").length !== 0 && $(this).find("textarea").val() === ''){
                $(this).removeClass("focused");
            }
		});
        inputs.each(function(){
            if($(this).find("input").length !== 0 && $(this).find("input").val() !== ''){
                $(this).addClass("focused");                
            }
            if($(this).find("select").length !== 0 && $(this).find("select").val() !== ''){
                $(this).addClass("focused");                
            }
            if($(this).find("textarea").length !== 0 && $(this).find("textarea").val() !== ''){
                $(this).addClass("focused");                
            }
        });
	};
	
	var formAnimate = Fw.component.export('formAnimate', {
		init: init
	});
	
})(jQuery);
